import { useCartData } from "@/zustand/cartStore.js";

const state = useCartData.getState();

if (!state.__childPatched) {
  useCartData.setState((currentState) => ({
    ...currentState,

    premiumShippingUpsellEnabled: false,

    setPremiumShippingUpsellEnabled: (enabled) => {
      useCartData.setState({ premiumShippingUpsellEnabled: enabled });
    },

    __childPatched: true,
  }));
}
